import { Box, Button, Container, Typography } from "@mui/material";
import { images } from "../../assets";
import en from "../../locales/en.json";
import es from "../../locales/es.json";
import it from "../../locales/it.json";
import fr from "../../locales/fr.json";
import de from "../../locales/de.json";
import pt from "../../locales/pt.json";
import ru from "../../locales/ru.json";
import zh from "../../locales/zh.json";
import ja from "../../locales/ja.json";
import ko from "../../locales/ko.json";
import ar from "../../locales/ar.json";
import hi from "../../locales/hi.json";
import nl from "../../locales/nl.json";
import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";

const locales = { en, es, it, fr, de, pt, ru, zh, ja, ko, ar, hi, nl };
const Verified = () => {
  const location = useLocation();
  const language = location?.state?.language || "en";
  const url = location?.state?.url;

  // Ensure we have a valid locale object, with defensive checks
  const selectedLocale = locales[language];
  const fallbackLocale = locales.en || {};
  const t = selectedLocale || fallbackLocale;

  const [countdown, setCountdown] = useState(15);

  // Fallback content if translations are missing
  const verifiedMessage = t?.verified?.message || "Verification successful!";
  const buttonText = t?.verified?.button || "Proceed";
  const hasTranslationError = !t?.verified;

  // Countdown timer and auto-redirect logic
  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prevCountdown) => {
        if (prevCountdown <= 1) {
          clearInterval(timer);
          // Auto-redirect when countdown reaches 0
          if (url) {
            window.location.href = url;
          }
          return 0;
        }
        return prevCountdown - 1;
      });
    }, 1000);

    // Cleanup timer on component unmount
    return () => clearInterval(timer);
  }, [url]);

  const handleProceedClick = () => {
    if (url) {
      window.location.href = url;
    }
  };

  return (
    <Box sx={{ bgcolor: '#f5f5f7', minHeight: '100vh' }}>
      <Box display="flex" justifyContent="center" sx={{ pt: { xs: 4, md: 6 } }}>
        <img
          src={images.certageLogo}
          alt="Logo"
          style={{
            width: "min(70vw, 300px)",
            height: "auto",
            maxHeight: "140px",
          }}
        />
      </Box>

      <Container>
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          gap={2}
          sx={{ height: { xs: "40vh", md: "60vh" } }}
        >
          <img
            src={images.certageCheckmar}
            alt="Logo"
            style={{
              width: "min(70vw, 300px)",
              height: "auto",
              maxHeight: "140px",
            }}
          />
          <Typography textAlign="center" fontSize={20} color="primary.text">
            {verifiedMessage}
          </Typography>
          {hasTranslationError && (
            <Typography textAlign="center" fontSize={12} color="error" sx={{ mt: 1 }}>
              [Translation Error - Language: {language}]
            </Typography>
          )}
        </Box>
        <Box
          display={"flex"}
          justifyContent={"center"}
          sx={{ width: { xs: "100%", md: "70%" } }}
          mx="auto"
        >
          <Button
            fullWidth={false}
            onClick={handleProceedClick}
            sx={{
              backgroundColor: "#1818de",
              px: { xs: 0, sm: 5 },
              py: 1.5,
              width: "70%",
              mx: "auto",
              borderRadius: "12px",
              mb: 2,
              fontSize: { xs: 16, sm: 24 },
              fontWeight: 600,
              color: "#fff",
              "&:hover": { backgroundColor: "#1515b0" },
            }}
          >
            {buttonText} ({countdown}s)
          </Button>
        </Box>
      </Container>
    </Box>
  );
};

export default Verified;
